document.addEventListener('DOMContentLoaded', function () {

    const headers = document.querySelectorAll('.accordion-header');

    headers.forEach(header => {
        header.addEventListener('click', () => {
            const currentlyActive = document.querySelector('.accordion-header.active');

            if (currentlyActive && currentlyActive !== header) {
                const activeContent = currentlyActive.nextElementSibling;
                currentlyActive.classList.remove('active');
                activeContent.classList.remove('open');

                setTimeout(() => {
                    activeContent.style.display = 'none';
                }, 300);
            }

            const content = header.nextElementSibling;
            const isActive = header.classList.contains('active');

            if (!isActive) {
                header.classList.add('active');
                content.style.display = 'block';
                setTimeout(() => {
                    content.classList.add('open');
                }, 10);
            } else {
                header.classList.remove('active');
                content.classList.remove('open');
                setTimeout(() => {
                    content.style.display = 'none';
                }, 300);
            }
        });
    });

    function openFaqItem(item) {
        if (!item) return;
        const header = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');
        if (!header || !content) return;

        header.classList.add('active');
        content.style.display = 'block';
        requestAnimationFrame(() => content.classList.add('open'));
        item.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function findFaqItem(rawId) {
        if (!rawId) return null;
        const id = rawId.replace(/^faq-/, '');
        return (
            document.querySelector(`.accordion-item[data-faq-id="${CSS.escape(id)}"]`) ||
            document.getElementById(`faq-${id}`) ||
            document.querySelector(`.accordion-item.${CSS.escape(id)}`)
        );
    }

    const urlParams = new URLSearchParams(window.location.search);
    const queryId = urlParams.get('faq_id');
    const hashId = window.location.hash ? window.location.hash.slice(1) : null;

    const target = findFaqItem(queryId) || findFaqItem(hashId);
    if (target) {
        // Defer scroll so layout settles first (fonts, images above the fold).
        setTimeout(() => openFaqItem(target), 50);
    }

    window.addEventListener('hashchange', () => {
        const next = findFaqItem(window.location.hash.slice(1));
        if (next) openFaqItem(next);
    });
});
